import React, { Component } from "react";
import { connect } from "react-redux";

import InputAmount from "../InputAmount";
import * as denominatorActions from "../../actions/denominator-actions";
import xss from "xss";

class DenominatorItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      amount: this.props.item ? this.props.item.amount : 0
    };
    this.updateValue = this.updateValue.bind(this);
    this.changeDenomination = this.changeDenomination.bind(this);
    this.onblur = this.onblur.bind(this);
  }

  updateValue(value) {
    this.setState({
      amount: value
    });
  }

  calculateAmount(amount) {
    amount = (isNaN(amount) && amount === "") ? 0 : parseInt(amount);
    const count = Math.round(amount / this.props.item.note);
    return this.props.item.note * count;
  }

  changeDenomination(event) {
    if (!event || !event.target) return;
    const { item, dispatch, onblur } = this.props;
    const timeout = this.props.configStorage.getCalculationTimeout();
    const setState = this.setState.bind(this);
    setState({
      amount: Number(event.target.value)
    });
    if (!this.props.basketStorage.locked) {
      item.amount = xss(event.target.value);
      if (item.timeout != null) {
        window.clearTimeout(item.timeout);
      }
      item.timeout = window.setTimeout(function () {
        item.timeout = null;
        dispatch(denominatorActions.changeDenomination(item));
        setState({
          amount: item.amount
        });
        if (typeof onblur === "function") {
          onblur(item);
        }
      }, timeout);
    }
  }

  onblur(event) {
    if (!event || !event.target) return;
    let item = this.props.item;
    item.amount = this.calculateAmount(Number(event.target.value));
    this.setState({
      amount: item.amount
    });
    if (typeof this.props.onblur === "function") {
      this.props.onblur(item);
    }
  }

  render() {
    let item = this.props.item || {};
    let basketStorage = this.props.basketStorage;

    return (
      <div className="ser-note-box ser-iblock">
        <div className="ser-note-title ser-iblock">{item.note} Note:</div>
        <InputAmount
          className={"ser-note-input ser-iblock"}
          value={this.state.amount}
          updateValue={this.updateValue}
          onchange={this.changeDenomination}
          onblur={this.onblur}
          disabled={this.props.locked || basketStorage.locked}
          number
          step={item.note}
          aria-label={"Betrag in " + item.note + " Noten"}
        />
      </div>
    );
  }
};
export default connect((store) => {
  return {
    configStorage: store.configStorage,
    basketStorage: store.basketStorage
  };
})(DenominatorItem);
